/**
 *
 * Basic login component union
 * adapt to Meituan and DianPing, both main APP and M website
 */

var GetUA = require('@dp/util-m-ua');

var DPAPP = 'dpapp';
var MTAPP = 'mtgroup';
var DPMW = 'dianping';
var MTMW = 'meituan';

var ua = GetUA()

/**
 *
 * @param succ login成功回调
 * @param fail login失败回调
 * @param customUA 自定义UA信息
 */
var login = function (succ, fail, customUA) {
	ua = customUA || ua
	_envSwitch(
		//KNB action
		function () {
			KNB.login({
				success: function (user) {
					typeof succ == "function" && succ(user);
				},
				fail: function () {
					typeof fail == "function" && fail();
				}
			});
		},
		//web action
		function () {
			location.href = _getUrl();
		}
	);
};

login.check = function (cb, customUA) {
	ua = customUA || ua
	_envSwitch(
		//KNB action
		function () {
			KNB.getUserInfo({
				success: function (user) {
					_checkLoginAjax(function (isLogin) {
						var checkResult = { isLogin: isLogin };
						isLogin ? checkResult.userInfo = user : checkResult.userInfo = {};
						cb(checkResult);
					}, user.token);
				},
				fail: function () {
					typeof cb == "function" && cb({ isLogin: false, userInfo: {} });
				}
			})
		},
		//web action
		function () {
			_checkLoginAjax(
				function (isLogin) {
					cb({ isLogin: isLogin, userInfo: {} });
				}
			);
		}
	);
}

/**
 * @param afterCheck cb
 * @param token if KNB，post token to Backend
 */
function _checkLoginAjax(afterCheck, token) {
	var checkUrl = "https:" + (ua.env == "product" ? "//m.dianping.com" : "//m.51ping.com") + "/account/ajax/checkLogin";
	var ajaxData = token ? { token: token } : {};
	if (window.$ && window.$.ajax) {
		window.$.ajax({
			url: checkUrl,
			type: 'POST',
			timeout: 5000,
			xhrFields: {
				withCredentials: true
			},
			data: ajaxData,
			success: function (res) {
				console.log('checkLogin ajax succ' + JSON.stringify(res));
				typeof afterCheck == "function" && afterCheck(Boolean(res.login));
			},
			error: function (e) {
				console.error('checkLogin ajax failed!');
				typeof afterCheck == "function" && afterCheck(false);
			}
		})
	} else {
		require.ensure([], function () {
			var reqwest = require('reqwest');
			reqwest({
				url: checkUrl,
				type: 'json',
				method: 'post',
				contentType: 'application/x-www-form-urlencoded',
				withCredentials: true,
				headers: {},
				data: ajaxData,
				error: function (err) {
					console.error('checkLogin ajax failed');
					typeof afterCheck == "function" && afterCheck(false);
				},
				success: function (resp) {
					console.log('checkLogin ajax succ' + JSON.stringify(resp));
					typeof afterCheck == "function" && afterCheck(Boolean(resp.login));
				}
			})
		}, 'reqwest');
	}
}

function _envSwitch(knbAction, webAction) {
	if (ua.type === DPAPP || ua.type === MTAPP) {
		if (!window.KNB) {
			require.ensure([], function () {
				var KNB = require('@dp/knb');
				KNB.ready(function () {
					typeof knbAction == "function" && knbAction();
				});
			}, 'knb');
		} else {
			window.KNB.ready(function () {
				typeof knbAction == "function" && knbAction();
			});
		}
	} else {
		typeof webAction == "function" && webAction();
	}
}

function _getUrl() {
	var PROTOCOL = location.protocol;
	var REDIRECT = location.href;
	var source = ua.source;
	var env = ua.env;
	var domain;
	var path;
	switch (source) {
		case DPMW:
			if (env === 'product') {
				domain = '//m.dianping.com';
			} else {
				domain = '//m.51ping.com';
			}
			path = '/login?redir=' + encodeURIComponent(REDIRECT);
			break;
		case MTMW:
			if (env === 'product') {
				domain = '//i.meituan.com';
			} else {
				domain = '//i.wpt.test.sankuai.com';
			}
			path = '/account/login?backurl=' + encodeURIComponent(REDIRECT);
			break;
		default:
			domain = '//m.dianping.com';
			path = '/login?redir=' + encodeURIComponent(REDIRECT);
			break;
	}
	return PROTOCOL + domain + (path || '');
}

module.exports = login;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/util-login/thunk.js
// module id = 473
// module chunks = 1 12 14